module.exports = __webpack_public_path__ + "img/level6-11.c56adc0d.png";